const ATC_BASE_PATH = "/wyszukiwarka-lekow/atc";

export function getAtcUrlPath(code: string): string {
  const segments: string[] = [];
  const len = code.length;
  if (len >= 1) segments.push(code.substring(0, 1));
  if (len >= 3) segments.push(code.substring(0, 3));
  if (len >= 4) segments.push(code.substring(0, 4));
  if (len >= 5) segments.push(code.substring(0, 5));
  if (len >= 7) segments.push(code.substring(0, 7));
  return `${ATC_BASE_PATH}/${segments.join("/")}`;
}

/**
 * Returns the set of ATC codes that should be expanded in the accordion
 * to make `code` visible and open — includes all ancestors and the item itself.
 */
export function getAtcExpandedCodes(code: string): Set<string> {
  const segments: string[] = [];
  const len = code.length;
  if (len >= 1) segments.push(code.substring(0, 1));
  if (len >= 3) segments.push(code.substring(0, 3));
  if (len >= 4) segments.push(code.substring(0, 4));
  if (len >= 5) segments.push(code.substring(0, 5));
  if (len >= 7) segments.push(code.substring(0, 7));
  return new Set(segments);
}

/** Recursively finds an AtcItem by code in the nested tree. */
export function findAtcItem(items: AtcItem[], code: string): AtcItem | null {
  for (const item of items) {
    if (item.code === code) return item;
    if (item.children) {
      const found = findAtcItem(item.children, code);
      if (found) return found;
    }
  }
  return null;
}
